import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { CategoryDTO, CategoryImageDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';



@Injectable()
export class CategoryService implements OnInit {
    public Categories: CategoryDTO[];
    public Source: LocalDataSource;

    constructor(private http: HttpClient, private notifcationService: NotificationService) {
        this.Source = new LocalDataSource();
        //this.Categories=new Array<CategoryDTO>();
    }

    addCategory(Category: CategoryDTO) {

        return this.http.post(environment.apiUrl + "/Category", Category).subscribe(
            data => {
                this.notifcationService.showSuccess("Category", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Category", "ajout avec success");
                console.error(error);
            }
        );

    }

    updateimgCategory(categoryImg:CategoryImageDTO){
        return this.http.put(environment.apiUrl + "/Category/CategoryProduct", categoryImg).subscribe(
            data => {
                this.notifcationService.showSuccess("Category", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Category", "ajout avec success");
                console.error(error);
            }
        );
    }

    updateCategory(Category: CategoryDTO) {

        return this.http.put(environment.apiUrl + "/Category", Category).subscribe(
            data => {
                this.notifcationService.showSuccess("Category", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Category", "ajout avec success");
                console.error(error);
            }
        );

    }


    getCategories(source: boolean): any {
        if (source) {
            this.http.get<CategoryDTO[]>(environment.apiUrl + "/Category").pipe(
                catchError(this.handleError)

            );
        } else {
            this.http.get<CategoryDTO[]>(environment.apiUrl + "/Category").pipe(
                catchError(this.handleError)

            );
        }

    }

    getAllCategories(): any {
        return this.http.get<CategoryDTO[]>(environment.apiUrl + "/Category")
            .pipe(
                catchError(this.handleError)
            );
    }




    deleteCategory(idCategory: number) {
        this.http.delete<any>(environment.apiUrl + "/Category/" + idCategory).subscribe(
            data => {
                this.notifcationService.showSuccess("Category", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Category", "suppression avec success");
                console.error(error);
            }
        );
    }

    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    };



}

